/**
 * @generated SignedSource<<98cfd80e9f86b1127255628f27ed2e51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateProjectPersonInput = {
  id: string;
  roleId?: string | null;
  isContactPerson?: boolean | null;
  hasDismissedSetToRunningNotification?: boolean | null;
  isProjectGroupUpdate?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateProjectPersonMutation$variables = {
  input: UpdateProjectPersonInput;
};
export type updateProjectPersonMutation$data = {
  readonly updateProjectPerson: {
    readonly projectPerson: {
      readonly isContactPerson: boolean | null;
      readonly role: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null;
  } | null;
};
export type updateProjectPersonMutation = {
  variables: updateProjectPersonMutation$variables;
  response: updateProjectPersonMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isContactPerson",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPersonPayload",
        "kind": "LinkedField",
        "name": "updateProjectPerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectPerson",
            "kind": "LinkedField",
            "name": "projectPerson",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPersonPayload",
        "kind": "LinkedField",
        "name": "updateProjectPerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectPerson",
            "kind": "LinkedField",
            "name": "projectPerson",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "661eb8d4e6de0e8c2a2a7d6052fadcb3",
    "id": null,
    "metadata": {},
    "name": "updateProjectPersonMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectPersonMutation(\n  $input: UpdateProjectPersonInput!\n) {\n  updateProjectPerson(input: $input) {\n    projectPerson {\n      isContactPerson\n      role {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "45a3bb3189bb8ca09de9b4ba6316a5c3";

export default node;
